import React, { Component } from "react";
import EditableDataContainer from "../containers/EditableDataContainer";
import BUILDIRQVaLoanBeforeView from "../views/IrqVaLoanBeforeView";
import ApiConfig from "../config/ApiConfig";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import { object, bool } from "yup";
import StatusCheck from "../components/StatusCheck";

class BuildIrqVaLoanBeforePage extends Component {
  render() {
    const submitEndpoint =
      ApiConfig.protocol + ApiConfig.apiUri + ApiConfig.irqEndpoint;

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <EditableDataContainer
          id="buildIrq"
          submitEndpoint={submitEndpoint}
          mutateRedux="always"
          isCreate
          isStep
          validationSchema={object().shape({
            vaFirstTimeUse: bool().required(),
          })}
        >
          <BUILDIRQVaLoanBeforeView
            content={contentMap.BuildIrqVaLoanBeforePage}
            navigationsAway={customNavigationMap.BuildIrqVaLoanBeforePage}
          />
        </EditableDataContainer>
      </div>
    );
  }
}

export default withRouterUtilities(BuildIrqVaLoanBeforePage);
